<template>
    <div>
        <h3 class="font-medium mb-4">Node Properties</h3>

        <div class="space-y-4">
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                    Label
                </label>
                <UInput
                    v-model="localData.label"
                    size="sm"
                    @update:model-value="updateNode"
                />
            </div>

            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                    Type
                </label>
                <div class="text-sm text-gray-600 p-2 bg-gray-100 rounded">
                    {{ localData.type }}
                </div>
            </div>

            <!-- Spark-specific properties -->
            <div v-if="localData.type === 'spark'">
                <label class="block text-sm font-medium text-gray-700 mb-1">
                    Spark Identifier
                </label>
                <UInput
                    v-model="localData.properties.sparkIdentifier"
                    size="sm"
                    placeholder="e.g., invoice-received"
                    @update:model-value="updateNode"
                />
            </div>

            <!-- Action-specific properties -->
            <div v-if="localData.type === 'action'">
                <label class="block text-sm font-medium text-gray-700 mb-1">
                    Action Type
                </label>
                <UInput
                    v-model="localData.properties.actionType"
                    size="sm"
                    placeholder="e.g., validate, process"
                    @update:model-value="updateNode"
                />
            </div>

            <!-- Branch-specific properties -->
            <div v-if="localData.type === 'branch'">
                <label class="block text-sm font-medium text-gray-700 mb-1">
                    Condition
                </label>
                <UInput
                    v-model="localData.properties.condition"
                    placeholder="e.g., amount > 1000"
                    size="sm"
                    @update:model-value="updateNode"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref, watch} from 'vue'
import type {Node} from '@vue-flow/core'
import type {WorkflowNodeData} from '@/workflow/types'

const props = defineProps<{
    node: Node<WorkflowNodeData>
}>()

const emit = defineEmits<{
    update: [nodeId: string, updates: Partial<WorkflowNodeData>]
}>()

const localData = ref({
    ...props.node.data,
    properties: props.node.data?.properties || {}
})

// Watch for external changes
watch(() => props.node.data, (newData) => {
    localData.value = {
        ...newData,
        properties: newData?.properties || {}
    }
}, {deep: true})

function updateNode() {
    emit('update', props.node.id, localData.value)
}
</script>
